module.exports = __webpack_public_path__ + "static/img/icon-4.dce0415.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon-4.png
// module id = Th+8
// module chunks = 1